import { EmptyState, Kpi } from "@/components/common";
import { useWorkspaceStats } from "@/hooks/useWorkspaces";

export function WorkspaceOverviewTab({ workspaceId }: { workspaceId: number }) {
  const { data: stats, isLoading } = useWorkspaceStats(workspaceId);

  if (isLoading) return <EmptyState icon="activity" title="Carregando…" />;
  if (!stats) return <EmptyState icon="activity" title="Sem dados" />;

  return (
    <>
      <div className="kpi-grid">
        <Kpi icon="users" tone="featured" label="Membros" value={String(stats.members_count)} />
        <Kpi icon="building" label="Organizações" value={String(stats.organizations_count)} sub="em breve" />
        <Kpi icon="briefcase" label="Empresas" value={String(stats.clients_count)} sub="em breve" />
      </div>
      <EmptyState
        icon="layers"
        title="Membros, convites e organizações chegam em breve"
        description="Estas seções serão habilitadas conforme os módulos de RBAC, convites e organizações forem entregues."
      />
    </>
  );
}
